





































import {
  checklistPostReq
} from "@/services/checklist.service";


export default  {
  data () {
    return {
      initLoaded: false,
      list: [],
      search: null, 
      headers: [
          { text: 'Datum',  value: 'created_at', sortable: false },
          { text: 'Projektname', value: 'projectname', sortable: false },
          { text: 'Inspektion', value: 'machine_name', sortable: false },
          { text: 'Benutzername', value: 'name' , sortable: false},
          { text: 'Passwort', value: 'pwd', sortable: false },
          { text: 'Eingegeben am', value: 'updated_at', sortable: false },
          { text: '', value: 'btn', sortable: false},
      ],
    }
  },
  mounted() {
    this.$store.state.headerTitle = "Finalisierung aufheben"

    checklistPostReq('finalize-pwd-list', { }) 
      .then(resp => {

        if (resp.data && resp.data.list) {
          this.list = resp.data.list
        }

        this.initLoaded = true
      })
      .catch(e => {
        this.$store.dispatch("api_error", e);
    }); 

  },
  methods: {
    deleteRow(item) {

      checklistPostReq('finalize-pwd-remove', { item: item }) 
        .then(resp => {

          if (resp.data && resp.data.list) {
            this.list = resp.data.list
          }
        })
        .catch(e => {
          this.$store.dispatch("api_error", e);
      }); 


    },
  }
}

